import { WARRANTY_YEARS } from './warranty';

// Stats-bar definitions shown on the homepage and the About page.
//
// Each stat's value and label are admin-editable from the Storefront panel
// (via the settings keys below). The verifiable claims here are the DEFAULTS
// shown when a field is left blank - so an unconfigured site never shows the
// old, unverifiable "350+ projects" figure. The `stat_*` value keys are the
// original storefront settings keys, kept so the existing admin fields keep
// driving the bar; the `*_label` keys are added for editable labels.
const STAT_DEFS = [
  { valueKey: 'stat_warranty',   labelKey: 'stat_warranty_label',   value: `${WARRANTY_YEARS} year`, label: 'Warranty from delivery' },
  { valueKey: 'stat_projects',   labelKey: 'stat_projects_label',   value: '37',                label: 'Sauleda fabric colourways' },
  { valueKey: 'stat_experience', labelKey: 'stat_experience_label', value: 'EN 13561 Class 3',  label: 'Wind tested by Intertek' },
  { valueKey: 'stat_custom',     labelKey: 'stat_custom_label',     value: 'Supply only',       label: "No install margin, no markup on someone else's labour" },
];

const pick = (settings, key, fallback) => {
  const v = settings ? settings[key] : undefined;
  return (v !== undefined && v !== null && String(v).trim() !== '') ? v : fallback;
};

// Build the stats array, applying any admin overrides from settings.
export function getCompanyStats(settings = {}) {
  return STAT_DEFS.map((d) => ({
    num: pick(settings, d.valueKey, d.value),
    label: pick(settings, d.labelKey, d.label),
  }));
}

// Default (unconfigured) stats, for any static consumer.
export const COMPANY_STATS = getCompanyStats();
